'use strict';

const authUrl = 'https://oauth.vk.com/authorize';
const scriptUrl = '//vk.com/js/api/openapi.js';
const photoVersions = [
  'xxbig',
  'xbig',
  'big'
];
const minPhotoSize = 320;

const vk = [
  '$window',
  '$state',
  '$q',
  'jsLoader',
  'auth',
  'config',
  'localStorage',

  function ($window, $state, $q, jsLoader, auth, config, localStorage) {
    var vkConfig = config.socials.vk;
    var loaderPromise;
    var VK;
    var vkSession;

    function getRedirectUrl() {
      var location = $window.location;

      return location.protocol + '//' + location.host + $state.href('vkLogin', { code: '' });
    }

    const getCurrency = () => localStorage.get('currency');

    function getLoaderPromise() {
      if (!loaderPromise) {
        loaderPromise = jsLoader(scriptUrl, 'VK')
          .then(function (vkApi) {
            var deferred = $q.defer();

            VK = vkApi;
            VK.init({
              apiId: vkConfig.appId
            });

            VK.Auth.getLoginStatus(function (response) {
              if (response.session) {
                vkSession = response.session;
              }

              deferred.resolve();
            });

            return deferred.promise;
          });
      }

      return loaderPromise;
    }

    function loginToVK() {
      var deferred = $q.defer();

      if (!vkSession) {
        VK.Auth.login(function (response) {
          if (response.session) {
            deferred.resolve(response.session);
          } else {
            deferred.reject();
          }
        }, vkConfig.scope);
      } else {
        deferred.resolve(vkSession);
      }

      return deferred.promise;
    }

    function getAlbums() {
      var deferred = $q.defer();
      var options = {
        'need_covers': 1,
        https: true
      };
      var albums;

      VK.Api.call('photos.getAlbums', options, function (response) {
        if (response.response) {
          albums = response.response.map(function (album) {
            return {
              id: album.aid,
              name: album.title,
              coverPhoto: album['thumb_src']
            };
          });
          deferred.resolve(albums);
        } else {
          deferred.reject(response);
        }
      });

      return deferred.promise;
    }

    function getPhotoUrl(photo) {
      var photoUrl = null;
      var total = photoVersions.length;
      var versionName;
      var iter;

      for (iter = 0; iter < total; iter++) {
        versionName = 'src_' + photoVersions[iter];
        if (photo[versionName]) {
          photoUrl = photo[versionName];
          break;
        }
      }

      return photoUrl;
    }

    function getPhotos(albumId) {
      var deferred = $q.defer();
      var options = {
        'album_id': albumId,
        https: true
      };
      var photos;

      VK.Api.call('photos.get', options, function (response) {
        if (response.response) {
          photos = response.response
            .filter(function (photo) {
              return photo.height >= minPhotoSize && photo.width >= minPhotoSize;
            })
            .map(function (photo) {
              return {
                id: photo.pid,
                albumId: photo.aid,
                src: getPhotoUrl(photo),
                url: photo.src
              };
            });
          deferred.resolve(photos);
        } else {
          deferred.reject(response);
        }
      });

      return deferred.promise;
    }

    return {
      login: function () {
        var promise = getLoaderPromise()
          .then(function () {
            return loginToVK();
          })
          .then(function (vkSession) {
            return auth.socialLogin('vk', vkSession.sid, vkSession.mid);
          });

        return promise;
      },

      loginWithCode: function (code) {
        return auth.login('/vk_code', {
          code: code,
          redirectUrl: getRedirectUrl(),
          currency: getCurrency()
        });
      },

      getPhotoPermissions: loginToVK,

      getAlbums: function (albumId) {
        var promise = getLoaderPromise()
          .then(function () {
            return loginToVK();
          })
          .then(function () {
            return getAlbums(albumId);
          });

        return promise;
      },

      getPhotos: function (albumId) {
        var promise = getLoaderPromise()
          .then(function () {
            return loginToVK();
          })
          .then(function () {
            return getPhotos(albumId);
          });

        return promise;
      },

      fetchScript: function () {
        return getLoaderPromise();
      },

      getAuthUrl: function () {
        return authUrl +
          '?client_id=' + vkConfig.appId +
          '&scope=' + vkConfig.scope +
          '&redirect_uri=' + getRedirectUrl() +
          '&response_type=code' +
          '&v=5.37';
      }
    };
  }
];

export default vk;



// WEBPACK FOOTER //
// ./app/src/services/vk.js